import { ChangeDetectionStrategy, Component, input, TemplateRef, ViewChild } from '@angular/core';
import { Params, QueryParamsHandling } from '@angular/router';

export type MenuItemLink = {
  rawUrl?: URL | string;
  routerLink?: string | string[];
  queryParams?: Params;
  queryParamsHandling?: QueryParamsHandling;
  routerLinkActive?: string;
  fragment?: string | null;
};

@Component({
  selector: 'lib-menu-item',
  template: `
    <ng-template #template>
      <ng-content></ng-content>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class MenuItemComponent {
  public menuItemLink = input<MenuItemLink>();
  public value = input<unknown>();
  public icon = input<string>();
  @ViewChild('template')
  public template: TemplateRef<unknown>;
}
